import * as React from "react"
import { memo } from "react"
import { withTheme } from "@material-ui/core/styles";

const ReturnToTerminalIcon = ({ width, height, theme }) => (
  <svg
    width={width ?? 24}
    height={height ?? 24}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m5.95 10.739 2.52 2.52c.095.09.213.137.336.137a.464.464 0 0 0 .335-.137l4.726-4.725-.005-.005a.47.47 0 0 0 0-.666L9.137 3.138a.47.47 0 0 0-.666 0l-2.519 2.52.646.69L8.806 4.14l4.059 4.059-4.059 4.059-2.209-2.21-.647.69Z"
      fill={theme.iconColor}
    />
    <path
      d="M9.278 7.963V10.325h-.945V7.963h-1.18v-.945h3.307v.945H9.278ZM4.336 5.214c-1.49 0-1.88 2.06-.493 2.605.154.06.318.092.483.093l.643.005v.004h.292l-.787-.787.689-.69 1.968 1.97-1.968 1.968-.69-.69.788-.787h-.59V8.9l-.351-.003a2.333 2.333 0 0 1-.836-.16c-2.4-.942-1.726-4.506.852-4.506h.85v.984h-.85Z"
      fill={theme.iconColor}
    />
  </svg>
);

export default memo(withTheme()(ReturnToTerminalIcon))
